<template>
  <div id="box">
    Basemap: Swisstopo, Data: Andri Baltensweiler, Contact: andri.baltensweiler@wsl.ch
  </div>
</template>

<script>
export default {
  name: "Credits"
}
</script>

<style scoped>
#box {
  height: 20px;
  width: 560px;
  opacity: 0.9;
  background-color: white;
  font-size: 10pt;
  padding-left: 5px;
  border-top-left-radius: 5px;
}

</style>
